// domain/publicLink — tautan halaman publik (murni, tested).
// Survei punya DUA cara masuk: per-tiket (#t=<token>, dari QR nota) dan per-cabang/pusat
// (#c=<KODE> / #c=ALL, link standing). Parsing-nya dipisah dari halaman supaya bisa diuji
// tanpa DOM, dan supaya kedua mode tak pernah saling tertukar.

export type SurveiMasuk =
  | { mode: 'token'; token: string }
  | { mode: 'cabang'; outlet: string } // outlet = kode cabang (huruf besar) atau 'ALL' (pusat)
  | { mode: 'kosong' };

/** Baca fragment (bagian setelah #). `#t=` menang bila keduanya ada. Kode cabang dinormalkan
 *  huruf besar; nilai kosong/aneh → 'kosong' (halaman menampilkan pesan, bukan menebak). */
export function parseSurveiHash(hash: string): SurveiMasuk {
  const q = new URLSearchParams((hash || '').replace(/^#/, ''));
  const t = (q.get('t') ?? '').trim();
  if (t) return { mode: 'token', token: t };
  const c = (q.get('c') ?? '').trim().toUpperCase();
  // Kode outlet iFiCs = huruf/angka pendek (mis. PKP, MTK) atau ALL. Batasi bentuknya supaya
  // nilai sampah tak diteruskan ke RPC sebagai "cabang".
  if (c && /^[A-Z0-9]{2,10}$/.test(c)) return { mode: 'cabang', outlet: c };
  return { mode: 'kosong' };
}

/** URL link survei standing untuk satu cabang (atau 'ALL' = pusat). `base` = alamatPublik(). */
export function surveiCabangUrl(base: string, kode: string): string {
  return `${base.replace(/\/+$/, '')}/survei.html#c=${encodeURIComponent(kode.toUpperCase())}`;
}
